import '@fortawesome/fontawesome-free/css/all.css'
import { reduce } from 'lodash'
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { localData } from '@/stores/local-data'
// import settingsSvg from '../assets/icons/settings.svg'

Vue.use(Vuetify)

export default new Vuetify({
  iconfont: 'fa',
  icons: {
    iconfont: 'fa',
    values: {
      // settings: settingsSvg,
    },
  },
  theme: {
    dark: !localData.lightmode,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: {
          base: '#E39345',
          lighten1: '#E39345',
          lighten3: '#E39345',
        },
        success: {
          base: '#5FCD5B',
          lighten1: '#dff5de',
        },
        secondary: '#424242',
        accent: '#0EB2E5',
        error: '#F44336',
        info: '#2196F3',
        warning: '#FFC107',
        grey1: '#A09E9A',
        subtitle: '#969696',
        red1: '#FF0000',
      },
      dark: {
        primary: {
          base: '#E39345',
          lighten1: '#150D1A',
          lighten2: '#2C2230',
          lighten3: '#211021',
        },
        success: {
          base: '#5FCD5B',
          lighten1: '#dff5de',
        },
        lightGray: '#969696',
        grey1: '#B9B9B1',
        subtitle: '#969696',
        red1: '#F6616A',
      },
    },
  },
})
